export const SET_ORGANIZATION_TYPES = '@@DICTIONARIES/SET_ORGANIZATION_TYPES';
